import { useEffect, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import ReactApiService from '../../services/reactApiService';

const useStyles = makeStyles((theme) => ({
	optionsTextArea: {
		height: '400px',
		width: '600px',
	},
	optionsCaption: {
		float: 'left'
	},
	optionsSkeleton: {
		marginLeft: '150px'
	}
}));

export default function TabControl(props) {
	
	const classes = useStyles();
  let [error, setError] = useState(false);
  let [options, setOptions] = useState([]);
  let [optionsCount, setOptionsCount] = useState(false);
  let [responseMessage, setResponseMessage] = useState('Loading ...');

	// keep function reference.
  const getOptions = useCallback(() => {
		const dataService = new ReactApiService();
		let loadedOptions = [];
		let arr = [];
		dataService.get('getRaw')
			.then( 
				(response) => {
					// console.log('Textareadata response :: ', response);
					if ( response.response === 'ok' ) {
						if ( 'object' === typeof response.options ) {
							for (var key in response.options) {
								if (response.options.hasOwnProperty(key)) {
									if ( response.options[key].length > 0 ) {
										arr = response.options[key].map( item => {
											return item;					
										}) 
										arr.unshift('Option: '+key+' | Length: '+arr.length);
										arr.push('---------------------');
										loadedOptions = loadedOptions.concat(arr);
										arr = [];
									}
								}
							}
						}
					} else {
						setResponseMessage((prev) => response.message );
					}
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					setError(error);
				}				
			)
			.then(
				() => {
					setOptionsCount((prev) => loadedOptions.length);
					setOptions((prev) => loadedOptions.join('\n'));		
				}
			)
  }, []) 	// optionsCount

	useEffect(() => {
		getOptions()
	}, [getOptions]);
	
	if ( error ) {
		return <div>Error: {error.message}</div>
	} else {
		if ( optionsCount === 0 ) {
			return ( 
				<div style={{height:200,width:'100%'}}>
					{responseMessage}
				</div> );
		} else {
			
			if ( optionsCount ) {
				return (	
					<div>
						<TextareaAutosize aria-label="maximum height" className={classes.optionsTextArea} defaultValue={options} />
					</div>
				)
			} else {
				return (	
					<div className={classes.optionsSkeleton}>
						<Stack spacing={1} className={classes.optionsTextArea} >
							<Skeleton variant="rectangular" width={600} height={400} />
						</Stack>
					</div>
				)			
			}
		}
	}
}
